module.exports = __webpack_public_path__ + "static/media/1.dcf71f37.mp4";